// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"5de75d3a","453":"d5bd9b9b","977":"b6bc5a51"}[chunkId] + ".chunk.js";
};